export default "__VITE_ASSET__BaNrtHhu__"